import { render } from "./newLoginSignup.vue?vue&type=template&id=5775931a"
import script from "./newLoginSignup.vue?vue&type=script&lang=js"
export * from "./newLoginSignup.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__